import { Chip, Button, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { createIncidentAPI } from "../../../utils/constants";
import Loading from "../../../../../../application/commons/loading/loading";

interface FormType {
  formType: string;
}

interface IncidentPayload {
  emailId: string;
  incidentDetails: IncidentDetails;
  attachments?: fileFormatProps[];
}

interface IncidentDetails {
  short_description: string;
  assignment_group?: string;
  impact?: number;
  description?: string;
  contact_type?: string;
  category?: string;
  subcategory?: string;
  work_notes?: string;
  urgency?: number;
}

interface fileFormatProps {
  type: string;
  sysId: string;
  fileData: string;
  name: string;
}

type IForm = {
  affectedApplication: string;
  shortDescription: string;
};

const Form: React.FC<FormType> = ({ formType }) => {
  const redirectUrl: string = useSelector(
    (state: any) => state.headers.redirectUrl
  );

  const userProfile = useSelector((store: any) => store.login.loginDetails);
  const [ticketNumber, setTicketNumber] = useState<string | null>(null);

  const [fileContent, setFileContent] = useState("");
  const [fileUpload, setFileUpload] = useState<fileFormatProps[]>([]);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IForm>();

  const onSubmit: SubmitHandler<IForm> = async (data: any) => {
    console.log("form data", fileUpload);
    const incidentDetails: IncidentDetails = {
      short_description: data.shortDescription,
      description: data.affectedApplication,
    };
    const payload: IncidentPayload = {
      emailId: userProfile.email,
      incidentDetails: incidentDetails,
      attachments: fileUpload.length > 0 ? fileUpload : [],
    };
    try {
      setLoading(true);
      await rasieTicket(payload);
      reset(); // Clear the form
      setFileUpload([]); // Clear uploaded files
      console.log("Form cleared successfully");
    } catch (error) {
      console.error("Error submitting the form:", error);
    }
  };

  const fileselect = () => {
    document.getElementById("file")?.click();
  };

  const FileChangeEvent = (e: any) => {
    console.log("event", e.target.files[0]);
    const files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      console.log("for loop");
      const reader = new FileReader();
      let CurrentFile = files[i];
      console.log(CurrentFile);
      reader.readAsDataURL(files[i]);

      reader.onload = (e) => {
        let fileType = CurrentFile.type;
        let fileName = CurrentFile.name;
        let base64Img = reader?.result as string;

        let ab = base64Img?.split(",");
        console.log("ab", ab);
        base64Img = ab[1];
        console.log(base64Img);

        fileFormat(fileType, "", fileName, base64Img);
        setFileContent(CurrentFile.name);
      };
    }
  };

  const fileFormat = (type: any, sysId: any, name: any, enData: any) => {
    const data: fileFormatProps = {
      type: type,
      sysId: sysId,
      fileData: enData,
      name: name,
    };
    setFileUpload((prevFiles) => [...prevFiles, data]);
    console.log("file upload", fileUpload);
  };

  const removeFile = (file: any) => {
    const index = fileUpload.indexOf(file);
    if (index > -1) {
      const updatedFiles = [...fileUpload];
      updatedFiles.splice(index, 1);
      setFileUpload(updatedFiles);
    }
  };

  const rasieTicket = async (incidentPayload: IncidentPayload) => {
    try {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(incidentPayload),
      };
      const result = await (await fetch(createIncidentAPI, options)).json();
      console.log("[RESULT]", result);
      if (result && result.number) {
        setLoading(false);
        setTicketNumber(result.number); // Store ticket number
      }
    } catch (err) {
      console.log("ERROR :::", err);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      {ticketNumber && (
        <div
          style={{ marginBottom: "10px", color: "green", textAlign: "center" }}
        >
          <p style={{ fontSize: "20px" }}>
            Ticket successfully created! Ticket number: {ticketNumber}
          </p>
        </div>
      )}

      {formType !== "Catalog" ? (
        <form
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="textboxt1">
            <div className="t1">
              <p>
                Affected Application <b style={{ color: "red" }}>*</b>
              </p>
            </div>
            <input
              type="text"
              {...register("affectedApplication", {
                required: {
                  value: true,
                  message: "Affected Application is required",
                },
              })}
              className="options1"
              style={{ color: theme.palette.mode === "dark" ? "white" : "" }}
            />
            {errors.affectedApplication && (
              <div className="error2">{errors.affectedApplication.message}</div>
            )}
          </div>
          <div className="textboxt2">
            <div className="description">
              <p>
                Short Description <b style={{ color: "red" }}>*</b>
              </p>
            </div>
            <textarea
              className="options2"
              style={{ color: theme.palette.mode === "dark" ? "white" : "" }}
              {...register("shortDescription", {
                required: {
                  value: true,
                  message: "Short Description is required",
                },
              })}
            ></textarea>

            {errors.shortDescription && (
              <div style={{ marginTop: "-28px" }} className="error2">
                {errors.shortDescription.message}
              </div>
            )}
          </div>

          <div className="attachment">
            <p
              className="attachmentheading"
              style={{ color: theme.palette.mode === "dark" ? "white" : "" }}
            >
              Attachment
            </p>
            <div className="info">
              Please refrain from uploading the personal data.
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {fileUpload?.length > 0 ? (
                <>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
                  >
                    {fileUpload.map((file, index) => (
                      <Chip
                        key={index}
                        color="primary"
                        label={file?.name}
                        onDelete={() => removeFile(file)}
                        icon={
                          <i
                            style={{ paddingLeft: "4px" }}
                            className="bi bi-image"
                          ></i>
                        }
                      />
                    ))}
                  </div>
                </>
              ) : (
                <></>
              )}
              <input
                type="file"
                accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .xls, .xlsx, .docx"
                id="file"
                value=""
                style={{ display: "none" }}
                multiple
                onChange={FileChangeEvent}
              />
              <div>
                <button
                  type="button"
                  className={theme.palette.mode === 'dark' ? 'attachbutton-dark': 'attachbutton'}
                  id="attachbtn"
                  onClick={fileselect}
                >
                  <div className="attachtext1">
                    <p style={{ margin: 0 }}>+ Attach a file</p>
                  </div>
                  <div
                    className="attachtext2"
                    style={{
                      color: theme.palette.mode === "dark" ? "white" : "",
                    }}
                  >
                    <p>200 mb file</p>
                  </div>
                </button>
              </div>

              {/* <div class="error3" id="error3" style="display: none;" >
                        {{i18nTexts.error}}</div> */}
            </div>
          </div>

          <div className="submit">
            <button type="submit" id="submit" className="btn btn-primary">
              <div className="wrapper">
                <div className="okayButton"></div>
                Submit
              </div>
            </button>
          </div>

          <Link
            to={`${redirectUrl}/desktop`}
            style={{ textDecoration: "none" }}
            className="submit"
          >
            <button className={`btn btn-${theme.palette.mode}`} id="cancel">
              {" "}
              Cancel{" "}
            </button>
          </Link>
        </form>
      ) : (
        <form
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          onSubmit={handleSubmit(onSubmit)}
        >
          Catalog form layout will be here
        </form>
      )}
    </>
  );
};

export default Form;
